import { Middleware, Context } from '@nuxt/types';

const hotjar: Middleware = (context: Context) => {
  // Identify the user for Hotjar on every page navigation.
  //
  // This identification is done 250ms after the page navigation because the window's
  // location is more likely to have been updated to the new page's URL in that time.
  // This allows Hotjar to associate this page view with the identified user.
  setTimeout(() => {
    context.app.$hotjar.identifyUser();
  }, 250);
};

export default hotjar;
